import $ from "jquery";
import { eventBus } from "../../../Annotations/helper/initialData";

//var { Timer } = require("easytimer.js");
import { Timer } from "easytimer.js";
var timerObjWithId = null;

const _createTimer = (startTime, endTime, timeObjWithId, setShowStudyExpirationPopup) => {
    if (timeObjWithId === null || typeof timeObjWithId === 'undefined') {
        timeObjWithId = {
            id: generateUniqueId(),
            timer: new Timer({ countdown: true, startValues: { seconds: startTime }, target: { seconds: endTime } }) // Create a new timer object
        };
        timerObjWithId = timeObjWithId;
        addListeners(timeObjWithId, setShowStudyExpirationPopup); 
    } else {
        timeObjWithId.timer.stop();
        timeObjWithId.timer.start({ countdown: true, startValues: { seconds: startTime }, target: { seconds: endTime } });
    }
    _startTimer(timeObjWithId);
};

const _startTimer = (timerObjWithId) => {
    if (timerObjWithId != null) {
        timerObjWithId.timer.start();
    }
};

export const updateTimer = (startTime, endTime, setShowStudyExpirationPopup) => {
    const timerObj = _getTimer();
    _createTimer(startTime, endTime, timerObj, setShowStudyExpirationPopup);
};


export const stopTimer = () => {
	const timerObj = _getTimer();
    if (timerObj?.timer) {
	    timerObj.timer.stop();
    }
}

export const resetTimer = () => {
	const timerObj = _getTimer();
    if (timerObj?.timer) {
	    try {
	    	timerObj.timer.stop();
	    } catch (e) {
	    	console.log("Error resetting timer:", e);
	    }
    }
    timerObjWithId = null;
    $('#reportTimerText').text("");
    $('#timerDisplayOnPopup').html("");
    hideTimer();
}

export const addListeners = (timerObjWithId, setShowStudyExpirationPopup) => {
    timerObjWithId.timer.addEventListener('targetAchieved', function (e) {
        handleStudyExpiration();
    });

    timerObjWithId.timer.addEventListener('secondsUpdated', function (e) {
        // $('#timerDisplayOnReportingPanel').html("Expire in " + timerObjWithId.timer.getTimeValues().toString());
        // $('#timerDisplayOnPopup').html("Study will expire in " + timerObjWithId.timer.getTimeValues().toString());
        // if (timerObjWithId.timer.getTimeValues().seconds === 0 && timerObjWithId.timer.getTimeValues().minutes === 5) {
        //     console.log("Timer is at 5 minutes.");
        //     setShowStudyExpirationPopup(true);
        // }

        const t = timerObjWithId.timer.getTimeValues();
        const mmss = t.hours > 0
            ? `${String(t.hours).padStart(2, '0')}:${String(t.minutes).padStart(2, '0')}:${String(t.seconds).padStart(2, '0')}`
            : `${String(t.minutes).padStart(2, '0')}:${String(t.seconds).padStart(2, '0')}`;

        $('#reportTimerText').text("Expire in " + mmss);
        $('#timerDisplayOnReportingPanel').show();
        $('#timerDisplayOnPopup').html("Study will expire in " + mmss);

        if (t.minutes === 5 && t.seconds === 0) {
            eventBus.dispatch("toggleFullscreen", {
                show: true,
            });
            setShowStudyExpirationPopup(true);
        }
    });
}

export const showTimer = () => {
    const timerObj = _getTimer();
    if (timerObj) {
        $('#timerDisplayOnReportingPanel').show();
        $('#timerDisplayOnPopup').show();
    }
};

export const hideTimer = () => {
    $('#timerDisplayOnPopup').hide()
    $('#timerDisplayOnReportingPanel').hide();
};

export const clearTimer = () => {
    resetTimer();
    $('#reportTimerText').text("");
    $('#timerDisplayOnPopup').html("");
};

const _getTimer = () => {
    return timerObjWithId || null;
};

const generateUniqueId = () => {
    return Math.random().toString(36).substr(2, 9);
};

const handleStudyExpiration = () => {
    console.log("study is expired.");
    eventBus.dispatch("configureStudyExpirationModal", {
        show: true,
      });
};



